"use strict";

exports.__esModule = true;
exports.SurfaceElement = SurfaceElement;
var _react = _interopRequireDefault(require("react"));
var _getNonWidgetProps = require("../../ConfigurableLayout/common/getNonWidgetProps");
var _Surface = require("../../Core/Surface");
var _excluded = ["width", "height", "children", "render"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Displays a surface which can draw children at arbitrary positions.
 */
function SurfaceElement(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 1024 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 768 : _ref$height,
    children = _ref.children,
    render = _ref.render,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Surface.Surface, _extends({
    width: width,
    height: height
  }, (0, _getNonWidgetProps.getNonWidgetProps)(extra)), render(children));
}